<template>
  <div class="hvh-flex space-between overflow-hidden" :class="(type || '').toLowerCase()" :title="label" @mousedown="$emit('mousedown', $event)">
    <div class="hvh-flex column center h-100 overflow-hidden" :class="{ clickable: $listeners['click'] }" @click="$emit('click', $event)">
      <span class="font-sm normal uppercase dpd-pill-title">{{ pillTitle }}</span>
      <div class="label hvh-flex overflow-hidden">
        <div class="truncate">{{ sentance }}</div>
        <div class="no-wrap ml-1" v-if="code">({{ code }})</div>
      </div>
    </div>

    <v-icon class="ml-1" :class="{ 'disabled spin': isLoading }" :color="getPillColor(type)" small @click="$emit('remove')" v-if="$listeners.remove">
      {{ isLoading ? 'mdi-timer-sand-empty' : 'mdi-close' }}
    </v-icon>
  </div>
</template>

<script>
import { getCriteriaSentance, getCriteriaCode, getCriteriaPillTitle, } from '../../../libraries/criteria'

var pillColors = [];

export default {
  props: ['label', 'type', 'title', 'isLoading'],

  computed: {
    code() {
      return getCriteriaCode(this.label);
    },
    sentance() {
      return getCriteriaSentance(this.label);
    },
    pillTitle() {
      return this.title || getCriteriaPillTitle({ type: this.type, label: this.label });
    },
  },
  methods: {
    getPillColor(type) {
      if (!pillColors.any()) {
        var styles = Array.from(document.styleSheets)
          .flatMap(f => Array.from(f.rules))
          .filter(f => (f.selectorText || '').indexOf('.pill.') > -1)
        pillColors = styles.map(f => ({ selector: f.selectorText, color: f.style.color }));
      }
      return (pillColors.find(f => f.selector.includes(`.pill.${type || 'tag'}`)) || {}).color;
    },
  },
}
</script>

<style lang="scss" scoped>
.pill {
  border: 1px solid #a5a8a9;
  border-radius: 23px;
  font-weight: 500;
  padding: 5px 12px;
  margin: 0 6px 6px 0;
  white-space: nowrap;

  /* Drugs */
  &.drugclass,
  &.drugdetail,
  &.druggeneric,
  &.drugbrand,
  &.drugform,
  &.drugstrength,
  &.drugndc {
    color: white;
    background-color: $background-color-drug;
    border-color: $background-color-drug;
  }
  
  /* USC */
  &.uscclass,
  &.uscdetail,
  &.uscgeneric,
  &.uscbrand,
  &.uscform,
  &.uscstrength,
  &.uscndc {
    color: white;
    background-color: $background-color-usc;
    border-color: $background-color-usc;
  }

  /* Diagnoses */
  &.dxgroup,
  &.dxname,
  &.dxcombo {
    color: white;
    background-color: $background-color-dx !important;
    border-color: $background-color-dx !important;
  }

  /* Procedures */
  &.procclass,
  &.procdescrip,
  &.proccombo {
    color: white;
    background-color: $background-color-proc !important;
    border-color: $background-color-proc !important;
  }

  /* Speciality */
  &.speciality {
    color: white;
    background-color: $background-color-speciality !important;
    border-color: $background-color-speciality !important;
  }

  /* Institutions */
  &.institutionsidn,
  &.institutionshco,
  &.institutionspg {
    color: white;
    background-color: $background-color-institutions !important;
    border-color: $background-color-institutions !important;
  }

  /* ER */
  &.er,
  &.costin,
  &.costout,
  &.prescription {
    color: white;
    background-color: $background-color-drug;
    border-color: $background-color-drug;
  }

  /* Cohorts */
  &.cohort {
    color: white;
    background-color: $background-color-cohort !important;
    border-color: $background-color-cohort !important;
  }

  &.physiciantype {
    color: white;
    background-color: $background-color-physiciantype !important;
    border-color: $background-color-physiciantype !important;
  }

  &.customfeature {
    color: white;
    background-color: $background-color-customfeature !important;
    border-color: $background-color-customfeature !important;
  }

  &.tag {
    color: #002f6c;
    background-color: white;
    border: 1px solid #acc8ce;
  }

  &.demographic {
    color: #002f6c;
    background-color: #a8c2e3;
    border-color: #a8c2e3;
  }

  &.bad-code {
    color: red;
    background-color: #ff6262;
    background-color: white;
    border: 1px solid red;
    min-height: 47px;
  }

  i {
    margin-right: -4px;
  }
}

.dpd-pill-title {
  opacity: 0.85;
}

.label {
  max-width: 600px;
}

.spin {
  animation: rotation 3s infinite linear;
}
</style>